import React, {useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router';
import {renderRoutes} from 'react-router-config';
import allRoutes from './routes';
import './utils/tools';
import './assets/styles/main.scss';
import SEO from './utils/SEO';
import {TopMenuBar, LeftMenu, Footer} from './components';
import Loader from './components/common/Loader';
import ReactGA from 'react-ga';
import CookieNotification from './components/complex/cookieNotification/cookieNotification';
import HeaderTickets from './components/complex/headerTickets/headerTickets';

function App({found = true, ...props}) {
    const history = useHistory();
    const location = useLocation();
    const [showSearch, setShowSearch] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const advancedMatching = {em: 'info@inclassica.com'}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
    const options = {
        autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
        debug: false, // enable logs
    };


    useEffect(() => {
        import('react-facebook-pixel')
            .then(module => module.default)
            .then(ReactPixel => {
                ReactPixel.init('724761092311966', advancedMatching, options)
                ReactPixel.pageView()
            })
    }, [location.pathname, history]);
    // const prevUrl = usePrevious(location.pathname);
    useEffect(() => {
        ReactGA.initialize('G-3ZN6Z7LH1S');
        ReactGA.pageview(window.location.pathname + window.location.search);
        // startLoader();
    }, [location.pathname, history]);
    return (
        <>
            {found && <SEO/>}

            <div>
                <Loader className={found === false ? 'hide' : ''}/>
                <div className='layer fadeIn'/>
                <div id='whiteLayer'/>
                <LeftMenu setShowSearch={setShowSearch} setIsFocused={setIsFocused}/>
                <HeaderTickets/>
                <TopMenuBar
                    showSearch={showSearch}
                    setShowSearch={setShowSearch}
                    isFocused={isFocused}
                    setIsFocused={setIsFocused}
                />
                <main>{renderRoutes(allRoutes)}</main>

                <Footer/>
                <CookieNotification/>
            </div>
        </>
    );
}

export default App;
